
<template>
<!-- v-show="echartsNum === 'second' && !ifTotal" -->
    <div class="powerEcharts"  :style="{width: echartsWidth}">
        <div v-show="!ifPart && echartsNum === 'first'" id="partEle"  :style="{width: echartsWidth,height:echartsHeight}"></div>
        <div style="text-align: center;" v-show="ifPart && (echartsNum === 'first')">暂无数据</div>
        <div style="text-align: center;" v-show="ifTotal && (echartsNum === 'second')">暂无数据</div>
        <div id="totalEle" v-show="echartsNum === 'second' && !ifTotal" :style="{width: echartsWidth,height:echartsHeight}">
        </div>    
    </div>
</template>

<script>
import { electricTrend, electricToday } from '@/api/admin/token';
export default {
    name: 'powerEcharts',
    data() {
        return {
            ifPart: false,
            ifTotal: false,
            all: 0,
            lineChart: null,
            barChart: null,
        };
    },
    computed: {
        echartsHeight: function() {
            // return document.body.clientHeight * 0.39 - 54 + 'px';
            return document.body.clientHeight * 0.46 - 100 + 'px';
        },
        echartsWidth: function() {
            return (document.body.clientWidth - 200 - 40) * 0.66 + 'px';
        }
    },
    props: {
        echartsNum: {
            type: String
        }
    },
    mounted() {
        this.getEchartsData()
    },
    methods: {
        getEchartsData () {
            this.stationId = sessionStorage.getItem('stationId')
            if (!this.stationId || this.stationId=='null') {
                this.$message.error('请先分配配设备！')
                return
            }
            this.getelectricPercentData()
            this.getelectricTrendData()
        },
        drawLine(data, pieData){
            // 基于准备好的dom，初始化echarts实例

            this.lineChart = echarts.init(document.getElementById('partEle'))
            var all = this.all
            // 绘制图表
            this.lineChart.setOption({
                title: [
                {   text:'当月逐日分时段堆积图',
                    textStyle: {
                        color: '#65B7E0',
                        fontSize: 14
                    },
                    left: '50%',
                    textAlign: 'center'
                },
                {    text:'当月占比环形图',
                        subtext: '总计:' + this.all + 'kw.h',
                    textStyle: {
                        color: '#65B7E0',
                        fontSize: 12
                    },
                    right: '0%',
                    top: '80%',
                    textAlign: 'center'
                }],
                legend: {
                    bottom: 5
                },
                tooltip: {
                    trigger: 'axis',
                    showContent: true,
                },
                dataset: {
                    source: data
                },
                xAxis: {
                    type: 'category',
                    axisLine: {
                        lineStyle: {
                            color: '#65B7E0'
                        }
                    },
                },
                yAxis: {
                    gridIndex: 0,
                    name: 'kw.h',
                    minInterval:1,
                    axisLine: {
                        lineStyle: {
                            color: '#65B7E0'
                        }
                    },
                },
                grid: {
                    top: '20%',
                    right: "20%",
                },
                series: [{
                        type: 'bar',
                        stack: '总量',
                        smooth: true,
                        color: '#2EC3D9',
                        seriesLayoutBy: 'row'
                    },
                    {
                        type: 'bar',
                        smooth: true,
                        color: '#92D401',
                        stack: '总量',
                        seriesLayoutBy: 'row'
                    },
                    {
                        type: 'bar',
                        color: '#F36757',
                        smooth: true,
                        stack: '总量',
                        seriesLayoutBy: 'row'
                    },
                    {
                        type: 'bar',
                        color: '#C23531',
                        smooth: true,
                        stack: '总量',
                        seriesLayoutBy: 'row'
                    },
                    {
                        type: 'pie',
                        id: 'pie',
                        radius:  ['20%', '50%'],
                        center: ['90%', '50%'],
                        data: pieData,
                        label: {
                            // formatter:function(param){ 
                            //     console.log(param)
                            //     var str = param.data[0] + ':'
                            //     var value = 0
                            //     for(let i = 1;i < param.data.length; i++) {
                            //         value += Number(param.data[i])
                            //     }
                            //     var percent = (value / all).toFixed(2) *  100
                            //     return str + '\n' + value + '\n(' + param.percent + '%)'
                            // },
                            formatter: '{b}:\n{c}\n{d}%',
                            position: 'inside',
                            fontSize: '10'
                        },
                        color: ['#2EC3D9', '#92D401', '#F36757', '#C23531'],
                        // encode: {
                        //     itemName: 'product',
                        //     value:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
                        // }
                    }
                ]
            });
        },
        drawbar(date, yestoday, today){
            // 基于准备好的dom，初始化echarts实例
            this.barChart = echarts.init(document.getElementById('totalEle'))
            // 绘制图表
            this.barChart.setOption({
                 title: {   text:'当日逐时用电曲线',
                    textStyle: {
                        color: '#65B7E0',
                        fontSize: 14
                    },
                    left: '50%',
                    textAlign: 'center'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['今日', '昨日'],
                    bottom: 5
                },
                grid: {
                    left: '3%',
                    right: '5%',
                    bottom: '15%',
                    top: '18%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: '#65B7E0'
                        }
                    },
                    data: date
                },
                yAxis: {
                    type: 'value',
                    name: 'kw.h',
                    minInterval:1,
                    axisLine: {
                        lineStyle: {
                            color: '#65B7E0'
                        }
                    },
                },
                series: [
                    {
                        name: '今日',
                        type: 'line',
                        stack: '总量',
                        smooth: true,
                        color: '#B4A3E9',
                        data: today,
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'},
                                {type: 'min', name: '最小值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }  
                    },
                    {
                        name: '昨日',
                        type: 'line',
                        color: '#2DC4D9',
                        stack: '总量',
                        smooth: true,
                        data: yestoday,
                        markPoint: {
                            data: [
                                {type: 'max', name: '最大值'},
                                {type: 'min', name: '最小值'}
                            ]
                        },
                        markLine: {
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        }
                    }
                ]
            });
        },
        getelectricTrendData() {
            this.ifPart = false
            electricTrend(this.stationId).then(res => {
                if (res.data.code === 0) {
                    if (res.data.data === null || res.data.data.length === 0) {
                        console.log('分时段无数据')
                        this.ifPart = true
                        if (this.lineChart!== null) {
                            this.lineChart.clear()
                        }
                        return
                    }
                    var dataList = res.data.data
                    let data = []
                    var llength = []
                    var all = 0
                    data[0] = ['product']
                    data[1] = ['谷']
                    data[2] = ['峰']
                    data[3] = ['平']
                    data[4] = ['尖']
                    var pieData = []
                    pieData[0] = {name: '谷', value: 0}
                    pieData[1] = {name: '峰', value: 0}
                    pieData[2] = {name: '平', value: 0}
                    pieData[3] = {name: '尖', value: 0}
                    for (let i = 0; i < dataList.length; i++) {
                        llength.push(i)
                        pieData[0].value += Number(dataList[i].grain)
                        pieData[1].value += Number(dataList[i].peak)
                        pieData[2].value += Number(dataList[i].flat)
                        pieData[3].value += Number(dataList[i].tip)
                        all = all + Number(dataList[i].grain) + Number(dataList[i].peak) + Number(dataList[i].flat) + Number(dataList[i].tip)
                        data[0].push(dataList[i].date)
                        data[1].push(Number(dataList[i].grain))
                        data[2].push(Number(dataList[i].peak))
                        data[3].push(Number(dataList[i].flat))
                        data[4].push(Number(dataList[i].tip))
                    }
                    // llength.shift();
                    this.all = all
                    console.log(llength)
                    console.log(data)
                    console.log(pieData)
                    this.drawLine(data, pieData)
                } else {
                    this.$message.error(res.data.msg)
                }
            });
        },
        getelectricPercentData() {
            this.ifTotal = false
            electricToday(this.stationId).then(res => {
                if (res.data.code === 0) {
                    var date = []
                    var yestoday = []
                    var today = []
                    var dataList = res.data.data
                    if (res.data.data === null || dataList.lastList.length === 0 ||  dataList.todayList.length === 0 ) {
                        this.ifTotal = true
                        if (this.barChart!== null) {
                            this.barChart.clear()
                        }
                        return
                    }
                    for (let i = 0; i < dataList.todayList.length; i++) {
                        var datea = dataList.todayList[i].time.slice(11,14) + ':00'
                        date.push(datea)
                        today.push(dataList.todayList[i].value)
                    }
                    for (let i = 0; i < dataList.lastList.length; i++) {
                        yestoday.push(dataList.lastList[i].value)
                    }
                    this.drawbar(date, yestoday, today)
                } else {
                    this.$message.error(res.data.msg)
                }
            });
        },
    }
};
</script>

<style scoped>
.powerEcharts {
    height: 100%;
}
#partEle{height: calc(100% - 54px);}
#totalEle{height: calc(100% - 54px);}
</style>
